import decode from 'jwt-decode';
import { apiLogin, apiCall } from '../helpers/axios';
import { CLIENT_ID, CLIENT_SECRET } from '../helpers/auth';

export const ME_URL = '/me';
export const AUTH_URL = '/oauth/token';

class AuthService {
	static authenticate(credentials) {
		return apiLogin.post(AUTH_URL, {
			...credentials,
			client_id: CLIENT_ID,
			client_secret: CLIENT_SECRET,
			grant_type: 'password',
		});
	}

	static getMe() {
		return apiCall().get(ME_URL);
	}
}

export default AuthService



// WEBPACK FOOTER //
// ./src/services/auth-service.js